import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { ContactFormDialogComponent } from '@app/common/components/contact-form-dialog/contact-form-dialog.component';

@Component({
  selector: 'app-cta-button',
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './cta-button.component.html'
})
export class CtaButtonComponent {
  private dialog = inject(MatDialog);

  @Input() text: string;
  @Input() small: boolean;
  @Input() fullWidth: boolean;
  @Input() additionalButtonClass: string;

  openContactDialog(): void {
    this.dialog.open(ContactFormDialogComponent);
  }
}
